﻿import $ from "jQuery";
import motivUi from "motivUi";

$(function () {
    $('#AddModel_VehiclePurchaseValue').on('change', updateBorrowingAmount)
    $('#AddModel_DesiredVehiclePrice').on('change', updateBorrowingAmount)
    $('#AddModel_Deposit').on('change', updateBorrowingAmount)
    $('#AddModel_PartExchangeValue').on('change', updateBorrowingAmount)
    $('#AddModel_SettlementValue').on('change', updateBorrowingAmount)

    updateBorrowingAmount();
});

function updateBorrowingAmount() {
    let purchaseVal = $('#AddModel_VehiclePurchaseValue').val();
    if (purchaseVal == '') {
        purchaseVal = $('#AddModel_DesiredVehiclePrice').val();
    }

    purchaseVal = stringToFloat(purchaseVal);
    let partExVal = stringToFloat($('#AddModel_PartExchangeValue').val());
    let settlementVal = stringToFloat($('#AddModel_SettlementValue').val());
    let depositVal = stringToFloat($('#AddModel_Deposit').val());

    $('[data-calculator-vehicle-price]').text(floatToCurrencyString(purchaseVal));
    $('[data-calculator-part-exchange]').text(floatToCurrencyString(partExVal));
    $('[data-calculator-cash-deposit]').text(floatToCurrencyString(depositVal));
    $('[data-calculator-settlement]').text(floatToCurrencyString(settlementVal));

    $('[data-calculator-cash-deposit-wrapper]').toggleClass("d-none", depositVal == '');
    $('[data-calculator-settlement-wrapper]').toggleClass("d-none", settlementVal == '');
    $('[data-calculator-part-exchange-wrapper]').toggleClass("d-none", partExVal == '');

    if (purchaseVal == '') {
        $('[data-calculator-container]').slideUp();
    }
    else {
        $('[data-calculator-container]').slideDown();
        let borrowingAmount = purchaseVal + settlementVal - depositVal - partExVal;
        $('[data-calculator-borrowing]').text("£" + floatToCurrencyString(borrowingAmount < 0 ? 0 : borrowingAmount));
        $('#AddModel_BorrowingAmount').val(borrowingAmount.toFixed(2));
        $('#AddModel_BorrowingAmount').valid();
    }
}

function stringToFloat(value) {
    if (!value) {
        return 0;
    }
    return parseFloat(motivUi.string.removeGroupSeparators(value))
}

function floatToCurrencyString(value) {
    value = value.toFixed(2);
    let decimals = value.toString().split('.')[1] || null;
    let groupSeparatedValue = motivUi.string.addGroupSeparator(value);
    let integerPart = groupSeparatedValue.split('.')[0];

    let stringVal = integerPart.split('.')[0];
    if (groupSeparatedValue.split('.').length > 1 && decimals) {
        stringVal += `.${decimals}`;
    }

    return stringVal;
}